import graphql__2d334a55e357278eab43 from "./__generated__/MapEventMarkers_map.graphql.js";import { graphql, useFragment } from "react-relay";

import MarkerClusterGroup from "../MarkerClusterGroup";
import { createMapMarkerClusterIcon } from "../createMapMarkerClusterIcon";
import MapEventMarker from "./MapEventMarker";

const MapEventMarkers = props => {
  const { events, markersMaxClusterRadius } = useFragment(MapEventMarkers_map, props.map);

  return (
    <MarkerClusterGroup
      showCoverageOnHover={false}
      maxClusterRadius={markersMaxClusterRadius}
      iconCreateFunction={createMapMarkerClusterIcon}
    >
      {events.map(event => (
        <MapEventMarker key={event.id} element={event} />
      ))}
    </MarkerClusterGroup>
  );
};

const MapEventMarkers_map = graphql__2d334a55e357278eab43;

export default MapEventMarkers;
